<div>
  <h1 class="email-label" nz-icon nzType="mail"></h1>
  <h1>{{'EMAIL_CONFIRMATION' | translate}}</h1>

  <div class="text-container">
    <div>
      <span>{{'EMAIL_CONFIRMATION_TEXT.TEXT1' | translate}}&nbsp;</span>
      <button nz-button nzType="link">{{email}}</button>
    </div>
    <span>{{'EMAIL_CONFIRMATION_TEXT.TEXT2' | translate}}</span>
    <div class="footer-text">
      <span>{{'EMAIL_CONFIRMATION_TEXT.TEXT3' | translate}}&nbsp;</span>
      <a nz-button nzType="link">{{'RESEND_CONFIRMATION_EMAIL' | translate}}&nbsp;</a>
      <span>{{'OR' | translate}}&nbsp;</span>
      <a nz-button nzType="link">{{'CONTACT_US' | translate}}</a>
    </div>
  </div>
</div>
